import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";
import { RowsAdmin } from "../../admin/RowsAdmin";
import { INTENT_RULE_FIELDS } from "../../admin/fields";

export function IntentRulesAdmin() {
  const probs = useQuery({ queryKey: ["kb-problems"], queryFn: () => api<{ problems: { id: string; title: string }[] }>("/api/admin/kb/problems") });
  const options = (probs.data?.problems ?? []).map((p) => ({ value: p.id, label: p.title }));
  return (
    <RowsAdmin title="Intent rules" versionType="intent_rule" apiBase="/api/admin/kb/intent-rules" rowsKey="rules" listKey="kb-intent-rules"
      intro="A rule links the words of a query to a customer problem. Groups joined by + must all appear; alternatives split by | are interchangeable; a word also matches longer words that start with it (evict → evicted, eviction). A higher weight ranks the problem and its programs higher."
      fields={INTENT_RULE_FIELDS} selectOptions={{ problemId: options }}
      describe={(r) => ({ primary: String(r.pattern), secondary: `→ ${String(r.problem_title)} · weight ${String(r.weight)}` })} />
  );
}
